import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPromotionForbidden } from './selectIsPromotionForbidden';
import { selectIsWithoutTopAndPremium } from './selectIsWithoutTopAndPremium';

export const selectIsDisabledPromotion = (state: IAppState): boolean => {
  const isBlockedOfferPublishBySanctions = selectIsPromotionForbidden(state);
  const isWithoutTopAndPremium = selectIsWithoutTopAndPremium(state);

  return isBlockedOfferPublishBySanctions || isWithoutTopAndPremium;
};
